<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="indigo darken-4">
      <v-toolbar-title>{{
        $vuetify.t('$vuetify.app.resetPassword')
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-avatar :tile="tile" size="32" color="grey lighten-4">
        <img src="/img/mobile-info-192.png" alt="avatar" />
      </v-avatar>
    </v-toolbar>
    <v-card-text>
      <v-alert :value="invalidCredentials" color="error">
        {{ $vuetify.t('$vuetify.app.invalidCredentials') }}
      </v-alert>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-text-field
          v-model="auth.username"
          label="Username"
          disabled
        ></v-text-field>
        <v-text-field
          label="Password"
          name="password"
          v-model="auth.password"
          hint="At least 6 characters"
          id="auth_password"
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          counter
        ></v-text-field>
        <v-text-field
          label="Password Repeat"
          name="password_confirmation"
          v-model="auth.password_confirmation"
          id="auth_password_confirmation"
          :append-icon="e2 ? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (e2 = !e2)"
          :type="e2 ? 'password' : 'text'"
          counter
        ></v-text-field>
        <v-card-actions>
          <v-btn @click="goLogin" flat left>Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" @click="submit" large dark>Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'reset',
  $validates: true,
  data() {
    return {
      loading: false,
      e1: true,
      e2: true,
      auth: {
        username: this.$route.params.username,
        token: this.$route.params.token,
        password: '',
        password_confirmation: ''
      },
      valid: false,
      errors: [],
      tile: null,
      invalidCredentials: false
    }
  },
  computed: {
    layout() {
      return 'login-layout'
    },
    isFormValid() {
      return (
        this.valid &&
        !Object.keys(this.fields).some(key => this.fields[key].invalid)
      )
    }
  },
  methods: {
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    ...mapActions({
      resetAction: 'root/reset',
      setLayout: 'root/setLayout',
      attachAuthHeader: 'root/attachAuthHeader'
    }),
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.invalidCredentials = false
        this.resetAction({ data: this.auth })
          .then(response => {
            this.loading = false
            this.setNotification(response.message)
            this.$router.push({ name: 'login' })
          })
          .catch(error => {
            this.loading = false
            this.setNotification(error.response.data.message)
            this.$refs.form.reset()
            this.$refs.form.validate()
          })
      }
    },
    goLogin() {
      this.$router.push({ name: 'login' })
    }
  },
  beforeCreate() {
    if (typeof this.$route.params.token === 'undefined') {
      this.$router.push({ name: 'login' })
    }
    if (this.$store.state.isLogged) {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
